var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProgress = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 21,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M5.467 10.477 8.6 11.9l1.422 3.134 1.421-3.134 3.134-1.422-3.134-1.421-1.421-3.135L8.6 9.056z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillRule: "evenodd",
  d: "M9.112 2.331V.5C7.025.682 5.139 1.52 3.617 2.787l1.294 1.294a8.13 8.13 0 0 1 4.2-1.75m7.316.456A10 10 0 0 0 10.934.5v1.831a8.13 8.13 0 0 1 4.2 1.75zM2.333 4.072l1.293 1.294a8.13 8.13 0 0 0-1.749 4.2H.046a10 10 0 0 1 2.287-5.494m15.836 5.494H20a10 10 0 0 0-2.287-5.494L16.42 5.366a8.14 8.14 0 0 1 1.75 4.2M3.226 15.033a8.16 8.16 0 0 0 6.797 3.645c3.572 0 6.606-2.297 7.727-5.477l1.785.41c-1.312 4-5.075 6.889-9.512 6.889-3.399 0-6.387-1.695-8.2-4.282v2.46H0V13.21h5.467v1.822z",
  clipRule: "evenodd"
})));
export { SvgProgress as ReactComponent };
export default __webpack_public_path__ + "e4dbb5f0d8647f91bf9c31a2919ef652.svg";